"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLOListElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLOListElementImpl, _HTMLElementImpl);

  function HTMLOListElementImpl() {
    _classCallCheck(this, HTMLOListElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLOListElementImpl).apply(this, arguments));
  }

  _createClass(HTMLOListElementImpl, [{
    key: "start",
    get: function get() {
      var value = parseInt(this.getAttributeNS(null, "start"));

      if (!isNaN(value)) {
        return value;
      }

      return 1;
    },
    set: function set(value) {
      this.setAttributeNS(null, "start", value);
    }
  }]);

  return HTMLOListElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLOListElementImpl
};